var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 32,
    viewBox: "0 0 43 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.785156,
    y: 0.5,
    width: 41,
    height: 31,
    rx: 7.5,
    stroke: "#FF9777"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0482 18.4606V13.0273L19.3149 14.7606L18.3815 13.794L21.7149 10.4606L25.0482 13.794L24.1149 14.7606L22.3815 13.0273V18.4606H21.0482ZM17.7149 21.1273C17.3482 21.1273 17.0342 20.9966 16.7729 20.7353C16.5115 20.474 16.3811 20.1602 16.3815 19.794V17.794H17.7149V19.794H25.7149V17.794H27.0482V19.794C27.0482 20.1606 26.9175 20.4746 26.6562 20.736C26.3949 20.9973 26.0811 21.1277 25.7149 21.1273H17.7149Z",
    fill: "#FF9777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.cc9d09c5e1e0dd356c1c626ee9c0020c.svg";
export { ForwardRef as ReactComponent };